import { API_CONFIG } from '../constants';
import { getStoredServiceToken, setStoredServiceToken, getRemainingTokenTime } from '../utils/helpers';

/**
 * Fetch service account token using client_credentials grant.
 * Returns { token, expiresIn } where expiresIn is seconds until expiry.
 */
export async function fetchServiceAccountToken(): Promise<{ token: string | null; expiresIn: number }> {
    // Check for a valid cached token first
    const existing = getStoredServiceToken();
    if (existing) {
        return { token: existing, expiresIn: getRemainingTokenTime() };
    }

    const tokenUrl =
        process.env.REACT_APP_TOKEN_URL ||
        `${process.env.REACT_APP_AUTH_ISSUER}/protocol/openid-connect/token`;
    const clientId = process.env.REACT_APP_SERVICE_CLIENT_ID;
    const clientSecret = process.env.REACT_APP_CLIENT_SECRET;

    if (!clientSecret) {
        console.warn("REACT_APP_CLIENT_SECRET not set; skipping service account token");
        return { token: null, expiresIn: 0 };
    }

    const params = new URLSearchParams({
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: "client_credentials",
    });

    const response = await fetch(tokenUrl, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
    });

    if (!response.ok) {
        const errBody = await response.text();
        throw new Error(`Service account token failed: ${response.status} ${errBody}`);
    }

    const data = await response.json();
    const token = data.access_token ?? null;
    const expiresIn = typeof data.expires_in === "number" ? data.expires_in : 0;
    if (token && expiresIn) {
        setStoredServiceToken(token, expiresIn);
    }
    return { token, expiresIn };
}

export async function signIn(podIp: string, accessToken: string): Promise<Response> {
    console.log('podIp-3', podIp);
    const params = new URLSearchParams({
        component_id: '5',
        pod_ip: podIp,
    });
    return await fetch(`${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.SIGN_IN}?${params.toString()}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${accessToken}`,
        }
    });
}